module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-set-e7a4fb4cf0018e0392f567e8eda7e2e5.svg";